import { render } from "./CompoundView.vue?vue&type=template&id=fa6c3a7a&scoped=true"
import script from "./CompoundView.vue?vue&type=script&lang=js"
export * from "./CompoundView.vue?vue&type=script&lang=js"

import "./CompoundView.vue?vue&type=style&index=0&id=fa6c3a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6c3a7a"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
